import { Injectable } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { CreditNotesService } from '../../creditnotes/creditnotes.service';
import { InvoiceService } from '../../invoices/invoice.service';
import { TransactionsService } from '../../transactions/transactions.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../_services';
import { InvoiceManualKnockOffService } from '../../invoices/invoice-knock-off/invoice.manual.knockoff.service';
import { RouteNavigationService } from '../../_services/routeNavigationService';

@Injectable({
  providedIn: 'root'
})
export class ListDisplayService {

  private defaultTableConfig = {
    cols: [],
    sortConfig: {
      order: '',
      field: ''
    },
    tablePageHelper: '',
    tableItemPageHelper: '',
    tableItemPageHelperRange: '',
    totalRecs: 0,
    page: 1,
    pageSize: 10,
    listData: { filters: {} },
    filteredList: [],
    currentPageDocuments: [],
    dataList: [],
    loading: false,
    showSelect: false,
    showActionsCol: true,
    selectAllToggle: false,
    actions: [],
    getDataFunction: (options) => { },
    onDataLoaded: () => { }
  };

  private listTypesTableConfig = {
    'invoices': {
      cols: [{
        name: 'LABELS.DOC_NUMBER',
        dataCol: 'docNo',
        id: 'invDocNo',
        columnName: 'docNo',
        isTemplate: true,
        sortable: true,
        sortFn: (a, b) => (a.docNo > b.docNo) ? 1 : -1
      }, {
        name: 'LABELS.SELLER',
        dataCol: 'sellerName',
        id: 'sellerName',
        columnName: 'sellerName',
        sortable: true,
        sortFn: (a, b) => (a.sellerName > b.sellerName) ? 1 : -1
      }, {
        name: 'LABELS.BUYER_CODE',
        dataCol: 'buyerCode',
        id: 'buyerCode',
        columnName: 'buyerCode',
        sortable: true,
        sortFn: (a, b) => (a.buyerCode > b.buyerCode) ? 1 : -1
      }, {
        name: 'LABELS.DUE_DATE',
        dataCol: 'dueDate',
        id: 'invDueDate',
        columnName: 'invDueDate',
        isTemplate: true,
        sortable: true,
        sortFn: (a, b) => a.dueDtForSort - b.dueDtForSort
      }, {
        name: 'LABELS.DUE_AMOUNT',
        dataCol: 'dueAmt',
        id: 'invDueAmt',
        columnName: 'formattedAmount',
        isAmount: true,
        amtProp: 'dueAmtDetails',
        sortable: true,
        isTemplate: true,
        sortFn: (a, b) => a.dueAmt - b.dueAmt
      }, {
        name: 'LABELS.STATUS',
        dataCol: 'overduemsg',
        id: 'overdueMsg',
        columnName: 'overduemsg',
        isTemplate: true,
        textEnd: true,
      }],
      getListData: (listConfig, options: any = {}) => {
        const getInvoicesFromService = () => {
          //console.log(listConfig);

          listConfig.loading = true;
          this.invoiceService.getInvoiceData(options).pipe(first()).subscribe((data: any) => {
            //console.log(data);

            listConfig.loading = false;
            listConfig.listData = data;
            listConfig.dataList = data.invoices;
            this.addPagingAndFilteInfo(listConfig);
            listConfig.onDataLoaded(data);
            //console.log(data);

            // TODO
            // Trigger callback
          }, () => {
            listConfig.loading = false;
          });
        };
        try {
          getInvoicesFromService();
        } catch (err) {
          listConfig.loading = false;
        }
      },
      actions: [{
        prop: 'docViewPath',
        text: 'LABELS.VIEW',
        action: 'view',
        id: 'viewBtn',
        class: ' fis-btn'
      }, {
        prop: 'allowPay',
        text: 'LABELS.PAY',
        action: 'pay',
        id: 'payBtn',
        class: ' fis-btn',
        // allowedRoles: ['1']
      }, {
        action: 'select',
        screenAction: false
      }],
      showSelect: false,
      checkIfSelectAllowed: () => {
        return true
      }
    },
    'transactions': {
      cols: [{
        name: 'LABELS.SELLER',
        dataCol: 'sellerName',
        id: 'sellerName',
        columnName: 'sellerName',
        sortable: true,
        sortFn: (a, b) => (a.sellerName > b.sellerName) ? 1 : -1
      },
      {
        name: 'LABELS.BUYER_CODE',
        dataCol: 'buyerCode',
        id: 'buyerCode',
        columnName: 'buyerCode',
        sortable: true,
        sortFn: (a, b) => (a.buyerCode > b.buyerCode) ? 1 : -1
      },
      {
        name: 'LABELS.TRANSACTION_NO',
        dataCol: 'tranNo',
        id: 'tranTxnNo',
        columnName: 'tranNo',
        sortable: true,
        sortFn: (a, b) => (a.tranNo > b.tranNo) ? 1 : -1
      }, /*{
        name: 'Customer Code',
        dataCol: 'buyerCode',
        id: 'buyerCode',
        columnName: 'buyerCode',
        sortable: true,
        sortFn: (a, b) => (a.buyerCode > b.buyerCode) ? 1 : -1
      },*/ {
        name: 'LABELS.TRANSACTION_DATE',
        dataCol: 'formattedTranDate',
        id: 'tranDate',
        columnName: 'formattedTranDate',
        sortable: true,
        sortFn: (a, b) => a.dtForSort - b.dtForSort
      }, {
        name: 'LABELS.PAYMENT_DATE',
        dataCol: 'formattedPayDate',
        id: 'tranPayDate',
        columnName: 'formattedPayDate',
        sortable: true,
        sortFn: (a, b) => a.dtForSort - b.dtForSort
      }, {
        name: 'LABELS.TRANSACTION_TOTAl',
        dataCol: 'tranAmtDetails.dispalyStr',
        id: 'tranTotal',
        columnName: 'formattedAmount',
        isTemplate: true,
        isAmount: true,
        amtProp: 'tranAmtDetails',
        sortable: true,
        sortFn: (a, b) => a.tranAmt.amt - b.tranAmt.amt
      }, {
        name: 'LABELS.PAID_AMOUNT',
        dataCol: 'bankAmtDetails.dispalyStr',
        id: 'tranPaidAmount',
        columnName: 'bankAmount',
        isTemplate: true,
        isAmount: true,
        amtProp: 'bankAmtDetails',
        sortable: true,
        sortFn: (a, b) => a.tranAmt.bankAmt - b.tranAmt.bankAmt
      }, {
        name: 'LABELS.STATUS',
        dataCol: 'statusTitle',
        id: 'tranStatus',
        columnName: 'statusTitle',
        isTemplate: true,
      }],
      getListData: (listConfig, options = {}) => {
        const getDataFromService = () => {
          listConfig.loading = true;
          this.transactionsService.getTransactions(options).pipe(first()).subscribe((data: any) => {
            listConfig.loading = false;
            listConfig.listData = data;
            listConfig.dataList = data.payHistoryList;
            this.addPagingAndFilteInfo(listConfig);
            listConfig.onDataLoaded(data);
          }, () => {
            listConfig.loading = false;
          });
        };
        try {
          getDataFromService();
        } catch (err) {
          listConfig.loading = false;
        }
      },
      actions: [{
        prop: 'tranNo',
        text: 'LABELS.DETAILS',
        action: 'detail',
        id: 'viewDetailsBtn',
        class: ' fis-btn'
      }]
    },
    'creditnotespending': {
      cols: [
        {
          name: 'LABELS.SELLER',
          dataCol: 'sellerNm',
          id: 'sellerName',
          columnName: 'sellerNm',
          sortable: true,
          sortFn: (a, b) => (a.sellerNm > b.sellerNm) ? 1 : -1
        },
        {
          name: 'LABELS.DOC_NUMBER',
          dataCol: 'docNo',
          id: 'cnDocNo',
          columnName: 'docNo',
          sortable: true,
          sortFn: (a, b) => (a.sellerNm > b.sellerNm) ? 1 : -1
        },
        {
          name: 'LABELS.DOC_DATE',
          dataCol: 'docDate',
          id: 'cnDocDate',
          columnName: 'docDate',
          sortable: true,
          sortFn: (a, b) => (a.docDtForSort > b.docDtForSort) ? 1 : -1
        },
        {
          name: 'LABELS.DUE_DATE',
          dataCol: 'dueDate',
          id: 'cnDueDate',
          columnName: 'dueDate',
          sortable: true,
          sortFn: (a, b) => (a.dueDtForSort > b.dueDtForSort) ? 1 : -1
        },
        {
          name: 'LABELS.DOC_AMOUNT',
          dataCol: 'docAmtDetails.dispalyStr',
          id: 'cnDocAmt',
          columnName: 'formattedDocAmount',
          isTemplate: true,
          isAmount: true,
          amtProp: 'docAmtDetails',
          sortable: true,
          sortFn: (a, b) => a.docAmt - b.docAmt
        },
        {
          name: 'LABELS.DUE_AMOUNT',
          dataCol: 'dueAmtDetails.dispalyStr',
          id: 'cnDueAmt',
          columnName: 'formattedAmount',
          isTemplate: true,
          isAmount: true,
          amtProp: 'dueAmtDetails',
          sortable: true,
          sortFn: (a, b) => a.dueAmt - b.dueAmt
        }

      ],
      getListData: (listConfig, options = {}) => {
        //console.log('');

        const getDataFromService = () => {
          listConfig.loading = true;
          this.creditNotesService.getCreditNotes('UNUSED', options).pipe(first()).subscribe((data: any) => {
            listConfig.loading = false;
            listConfig.listData = data;
            listConfig.dataList = data.list;
            this.addPagingAndFilteInfo(listConfig);
            listConfig.onDataLoaded(data);
          }, () => {
            listConfig.loading = false;
          });
        };
        try {
          getDataFromService();
        } catch (err) {
          listConfig.loading = false;
        }
      },
      actions: [{
        prop: 'docViewPath',
        text: 'LABELS.VIEW',
        action: 'view',
        id: 'viewBtn',
        class: ' fis-btn'
      }],
      showActionsCol: true
    },
    'creditnotesused': {
      cols: [
        {
          name: 'LABELS.SELLER',
          dataCol: 'sellerNm',
          id: 'sellerName',
          columnName: 'sellerNm',
          sortable: true,
          sortFn: (a, b) => (a.sellerNm > b.sellerNm) ? 1 : -1
        },
        {
          name: 'LABELS.DOC_NUMBER',
          dataCol: 'docNo',
          id: 'cnDocNo',
          columnName: 'docNo',
          sortable: true,
          sortFn: (a, b) => (a.sellerNm > b.sellerNm) ? 1 : -1
        },
        {
          name: 'LABELS.DOC_DATE',
          dataCol: 'docDate',
          id: 'cnDocDate',
          columnName: 'docDate',
          sortable: true,
          sortFn: (a, b) => (a.docDtForSort > b.docDtForSort) ? 1 : -1
        },
        {
          name: 'LABELS.DUE_DATE',
          dataCol: 'dueDate',
          id: 'cnDueDate',
          columnName: 'dueDate',
          sortable: true,
          sortFn: (a, b) => (a.dueDtForSort > b.dueDtForSort) ? 1 : -1
        },
        {
          name: 'LABELS.DOC_AMOUNT',
          dataCol: 'formattedDocAmount',
          id: 'cnDocAmt',
          columnName: 'formattedDocAmount',
          amtProp: 'docAmtDetails',
          isAmount: true,
          sortable: true,
          isTemplate: true,
          sortFn: (a, b) => a.docAmt - b.docAmt
        },
        {
          name: 'LABELS.DUE_AMOUNT',
          dataCol: 'formattedAmount',
          id: 'cnDueAmt',
          columnName: 'formattedAmount',
          amtProp: 'dueAmtDetails',
          isAmount: true,
          sortable: true,
          isTemplate: true,
          sortFn: (a, b) => a.dueAmt - b.dueAmt
        }],
      getListData: (listConfig, options = {}) => {
        const getDataFromService = () => {
          listConfig.loading = true;
          this.creditNotesService.getCreditNotes('USED', options).pipe(first()).subscribe((data: any) => {
            listConfig.loading = false;
            listConfig.listData = data;
            listConfig.dataList = data.list;
            this.addPagingAndFilteInfo(listConfig);
            listConfig.onDataLoaded(data);
          }, () => {
            listConfig.loading = false;
          });
        };
        try {
          getDataFromService();
        } catch (err) {
          listConfig.loading = false;
        }
      },
      actions: [{
        prop: 'docViewPath',
        text: 'LABELS.VIEW',
        action: 'view',
        id: 'viewBtn',
        class: ' fis-btn'
      }],
      showActionsCol: true
    },
    'invoices-knockoff': {
      cols: [{
        name: 'LABELS.SELLER',
        dataCol: 'sellerName',
        id: 'sellerName',
        columnName: 'sellerName',
        sortable: true,
        sortFn: (a, b) => (a.sellerName > b.sellerName) ? 1 : -1
      }, {
        name: 'LABELS.BUYER_CODE',
        dataCol: 'buyerCode',
        id: 'buyerCode',
        columnName: 'buyerCode',
        isTemplate: false,
        sortable: true,
        sortFn: (a, b) => (a.buyerCode > b.buyerCode) ? 1 : -1
      }, {
        name: 'LABELS.DOC_NUMBER',
        dataCol: 'docNo',
        id: 'invDocNo',
        columnName: 'docNo',
        isTemplate: true,
        sortable: true,
        sortFn: (a, b) => (a.docNo > b.docNo) ? 1 : -1
      }, {
        name: 'LABELS.DOC_DATE',
        dataCol: 'invoiceDate',
        id: 'invDocDate',
        columnName: 'invoiceDate',
        sortable: true,
        sortFn: (a, b) => a.docDtForSort - b.docDtForSort
      }, {
        name: 'LABELS.DUE_DATE',
        dataCol: 'invDueDate',
        id: 'invDueDate',
        columnName: 'invDueDate',
        sortable: true,
        sortFn: (a, b) => a.dueDtForSort - b.dueDtForSort
      }, {
        name: 'LABELS.DOC_AMOUNT',
        dataCol: 'formattedDocAmount',
        id: 'invDocAmt',
        columnName: 'formattedDocAmount',
        textEnd: true,
        amtProp: 'docAmtDetails',
        sortable: true,
        isTemplate: false,
        sortFn: (a, b) => a.docAmt - b.docAmt
      }, {
        name: 'LABELS.DUE_AMOUNT',
        dataCol: 'dueAmt',
        id: 'invDueAmt',
        columnName: 'formattedAmount',
        isAmount: true,
        amtProp: 'dueAmtDetails',
        sortable: true,
        isTemplate: true,
        sortFn: (a, b) => a.dueAmt - b.dueAmt
      }, {
        name: 'LABELS.STATUS',
        dataCol: 'overduemsg',
        id: 'overduemsg',
        columnName: 'overduemsg',
        isTemplate: true,
      }],
      getListData: (listConfig, options: any = {}) => {
        setTimeout(()=>{
          console.log("listConfig : ", listConfig, "options : ", options);
        },200);
        const getInvoicesFromService = () => {
          //console.log(listConfig);

          this.invoiceKnockOffService.getManualKnockOffLandingData().then(paymentData => {
            console.log("paymentData : ", paymentData);
            
            listConfig.loading = false;
            this.invoiceKnockOffService.getInvoicesForPayment(paymentData).subscribe(data => {
              console.log("data : ", data);
              
              listConfig.loading = false;
              listConfig.listData = data;
              listConfig.dataList = data.invoices;
              this.addPagingAndFilteInfo(listConfig);
              listConfig.onDataLoaded(data);
              console.log("listDisplayOptions : ", listConfig);
              if (!listConfig.dataList.length) {
                this.goToInvoices();
                // this.initListToScroll();
              } else {
                // this.initListToScroll();
                this.invoiceKnockOffService.processInvoiceSelectionForPayment(listConfig.listData);
              }
            }, () => {
            })
          });

          // listConfig.loading = true;
          // this.invoiceService.getInvoiceData(options).pipe(first()).subscribe((data: any) => {
          //   //console.log(data);

          //   listConfig.loading = false;
          //   listConfig.listData = data;
          //   listConfig.dataList = data.invoices;
          //   this.addPagingAndFilteInfo(listConfig);
          //   listConfig.onDataLoaded(data);
          //   //console.log(data);

          //   // TODO
          //   // Trigger callback
          // }, () => {
          //   listConfig.loading = false;
          // });
        };
        try {
          getInvoicesFromService();
        } catch (err) {
          listConfig.loading = false;
        }
      },
      actions: [{
        prop: 'docViewPath',
        text: 'LABELS.VIEW',
        action: 'view',
        id: 'viewBtn',
        class: ' fis-btn'
      }, {
        prop: 'allowPay',
        text: 'LABELS.PAY',
        action: 'pay',
        id: 'payBtn',
        class: ' fis-btn',
        allowedRoles: ['1']
      }, {
        action: 'select',
        id: 'selectBtn',
        screenAction: false
      }],
      showSelect: false,
      showActionsCol: false,
      hideTopFilter: true,
      checkIfSelectAllowed: () => {
        return true
      }
    },
  }

  showSearchInput = false;

  constructor(
    private invoiceService: InvoiceService,
    private transactionsService: TransactionsService,
    private creditNotesService: CreditNotesService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private invoiceKnockOffService: InvoiceManualKnockOffService,
    private routeNavService: RouteNavigationService,
  ) { }

  getDefaultTableConfig() {
    return Object.assign({}, this.defaultTableConfig);
  }

  getTableConfig(listType) {
    // const currentUserRole = this.authenticationService.currentUserValue();
    const tableConfig = Object.assign({}, this.defaultTableConfig, this.listTypesTableConfig[listType], {
      actions: this.listTypesTableConfig[listType]?.actions.filter(action => {
        if (typeof action.allowedRoles !== 'undefined') {
          return false;
        } else {
          return true;
        }
      })
    });
    if (tableConfig.checkIfSelectAllowed) {
      tableConfig.showSelect = tableConfig.checkIfSelectAllowed();
    }
    return tableConfig;
  }

  getListData(listConfig, options = {}) {
    listConfig.getListData(listConfig, options);
  }

  private addPagingAndFilteInfo(listConfig) {
    listConfig.filteredList = listConfig.dataList.filter(item => item.isVisible);
    listConfig.totalRecs = listConfig.filteredList.length;
    listConfig.page = listConfig.pageNo;
    let totalPage = listConfig.filteredList.length;
    totalPage = totalPage / 10;
    this.refreshPaginationInfo(listConfig);
  }

  private refreshPaginationInfo(listConfig, pageNo = 1) {
    listConfig.totalRecs = listConfig.filteredList.length;
    listConfig.page = pageNo;
    let totalPage = listConfig.filteredList.length;
    totalPage = totalPage / 10;
    this.updateTablePageHelper(listConfig);
    this.getPagedDocuments(listConfig);
  }

  private updateTablePageHelper(listConfig) {
    const { page, pageSize, totalRecs } = listConfig;
    const recStartIndex = ((page - 1) * pageSize) + 1;
    const endIndex = (recStartIndex + pageSize) - 1;
    const recEndIndex = (endIndex > totalRecs) ? totalRecs : endIndex;

    // listConfig.tablePageHelper = `Showing ${recStartIndex} to ${recEndIndex} of ${totalRecs} documents`
    listConfig.startIndex = recStartIndex;
    listConfig.endIndex = recEndIndex;
    listConfig.totalIndex = totalRecs;
    listConfig.tablePageHelper = 'LABELS.SHOWING_OUT_OF_DOCUMENTS';
    listConfig.tableItemPageHelper = 'LABELS.ITEMS_PER_PAGE';
    listConfig.tableItemPageHelperRange = 'LABELS.ITEMS_PER_PAGE_RANGE';
  }

  private getPagedDocuments(listConfig) {
    // console.log(listConfig);

    const startIndex = (listConfig.page - 1) * listConfig.pageSize;
    listConfig.currentPageDocuments = listConfig.filteredList.slice(startIndex, startIndex + listConfig.pageSize);
  }

  onPageChange(listConfig, pageNo) {
    listConfig.totalRecs = listConfig.filteredList.length;
    listConfig.page = pageNo;
    let totalPage = listConfig.filteredList.length;
    this.refreshPaginationInfo(listConfig, pageNo)
  }

  filtersApplied(listConfig) {
    this.addPagingAndFilteInfo(listConfig);
  }


  goToInvoices() {
    this.routeNavService.navigateRoot('invoices');
  }

  sortByField(listConfig, colConfig) {
    // Set config
    const sortConfig = listConfig.sortConfig;
    if (sortConfig.field === colConfig.dataCol) {
      if (sortConfig.order === 'asc') {
        sortConfig.order = 'desc';
      } else {
        sortConfig.order = 'asc';
      }
    } else {
      sortConfig.field = colConfig.dataCol;
      sortConfig.order = 'asc';
    };
    listConfig.dataList.sort((a, b) => {
      return (sortConfig.order === 'desc' ? -1 : 1) * colConfig.sortFn(a, b);
    });
    this.addPagingAndFilteInfo(listConfig);

  };

}
